export default "__VITE_ASSET__DYjnn7Kq__"